import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

/**
 * A reusable loading indicator component
 * @param {object} props - Component props
 * @param {string} props.message - Optional message to display
 * @param {number} props.size - Size of the indicator
 * @param {string} props.color - Color of the indicator
 * @returns {JSX.Element} - Loading indicator component
 */
const LoadingIndicator = ({ message = 'Loading...', size = 40, color = 'primary' }) => {
  return (
    <Box 
      display="flex" 
      flexDirection="column" 
      alignItems="center" 
      justifyContent="center" 
      p={2}
    >
      <CircularProgress size={size} color={color} />
      {message && (
        <Typography variant="body2" mt={1} color="text.secondary">
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingIndicator; 